
    import {PageRequest} from '@/store/shared/entity'
    import CreateCustomerSystemCode from './component/create-customer-systemcode.vue'
    import EditCustomerSystemCode from './component/edit-customer-systemcode.vue'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins,appConst } from "@/lib";
    import {systemConst} from '@/lib/consts/modules/system'

    class  PageSystemCodeRequest extends PageRequest{
        category:string;
    }

    @Component({
 name: "customersystemCode",
        components:{CreateCustomerSystemCode,EditCustomerSystemCode}
    })
    export default class Logistics extends  Mixins(PageResultBaseMixins,PageResultModalMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageSystemCodeRequest(),
            queryAction:"system/customersystemcode/getAll",
            isAutoQuery: true,
            cols:this.columns
        }

        get columns(){
            return [
                
                { title:this.L('app.SystemCode.Category'), key:'category', minWidth:260},
                { title:this.L('app.SystemCode.Code'), key:'code', minWidth:260},
                { title:this.L('app.SystemCode.CodeDescription_zh'), key:'codeDescription_zh', minWidth:260},
                { title:this.L('app.SystemCode.CodeDescription_en'), key:'codeDescription_en', minWidth:260},
                { title:this.L('app.SystemCode.AdditionValue'), key:'additionValue', minWidth:260},
                { title:this.L('app.SystemCode.SequenceNo'), key:'sequenceNo', width:80},
                { title:this.L('app.SystemCode.Remark'), key:'remark', minWidth:260},
                
                
                this.$util.render.actions(this.colButtons, ()=>{return {fixed: "right"}})
            ]
        }

        colButtonCheck = (row) => {
             return !row.isStatic;
        }

        get colButtons():ActionButtonConfig[]{ 
            return [
                this.colEditBtnM(row => this.colButtonCheck(row)),
                this.colDeleteBtn( row => this.colButtonCheck(row)),
            ]
        }

        async created(){
            
        }
 
        reset(){
            this.data.model = new PageSystemCodeRequest();
        }
        
        
        get categoryList() {
        return this.getCodeListByCategory(
        appConst.codeCategory.category
        );
    }
    }
